import { setConfig } from '@hubxco/hubx-smartlink';
import { type ReactNode } from 'react';

import { useRouteChange } from '@/lib/analytics/hooks/route-change';

import { AppConfig } from './AppConfig';
import { AppProvider } from './Provider';
import { AppRouter } from './Router';

setConfig({
  eventApiBaseUrl: import.meta.env.VITE_EVENT_API_BASE_URL as string,
});

export function App(): ReactNode {
  useRouteChange();

  return (
    <AppProvider>
      <AppConfig>
        <AppRouter />
      </AppConfig>
    </AppProvider>
  );
}
